import { render, staticRenderFns } from "./UploadImagemBannerPrincipalView2.vue?vue&type=template&id=cf6975e6&"
import script from "./UploadImagemBannerPrincipalView2.vue?vue&type=script&lang=js&"
export * from "./UploadImagemBannerPrincipalView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports